import { render, staticRenderFns } from "./Comparison.vue?vue&type=template&id=29f02cbe&"
import script from "./Comparison.vue?vue&type=script&lang=ts&"
export * from "./Comparison.vue?vue&type=script&lang=ts&"
import style0 from "./Comparison.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports